import { render, staticRenderFns } from "./SpecimensRecommendedModal.vue?vue&type=template&id=671582c8&scoped=true"
import script from "./SpecimensRecommendedModal.vue?vue&type=script&lang=js"
export * from "./SpecimensRecommendedModal.vue?vue&type=script&lang=js"
import style0 from "./SpecimensRecommendedModal.vue?vue&type=style&index=0&id=671582c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671582c8",
  null
  
)

export default component.exports